(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  href: _propTypes.string,
  info: _propTypes.string,
  text: _propTypes.string.isRequired,
  type: _propTypes.string,
  size: _propTypes.string,
  theme: _propTypes.string,
  outline: _propTypes.bool,
  cssClass: _propTypes.string,
  handleClick: _propTypes.func
};

// ImageCTA is a stateless functional component.
var Button = function Button(props) {
  var href = props.href,
    info = props.info,
    text = props.text,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    size = props.size,
    theme = props.theme,
    _props$outline = props.outline,
    outline = _props$outline === void 0 ? false : _props$outline,
    _props$cssClass = props.cssClass,
    cssClass = _props$cssClass === void 0 ? "" : _props$cssClass,
    handleClick = props.handleClick;
  var buttonSize = size ? "hl__button--".concat(size) : "";
  var buttonStyle = outline ? "hl__button--minor" : "";
  var buttonTheme = theme ? "hl__button--".concat(theme) : "";
  var buttonClass = "hl__button ".concat(buttonSize, " ").concat(buttonTheme, " ").concat(buttonStyle, " ").concat(cssClass);
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href,
      className: buttonClass,
      title: info
    }, text);
  } else {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: type,
      className: buttonClass,
      "aria-label": info,
      onClick: handleClick
    }, text);
  }
};
Button.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Button;

},{"prop-types":"prop-types","react":"react"}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  checked: _propTypes.bool.isRequired,
  icon: _propTypes.string,
  inline: _propTypes.bool,
  label: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  subLabel: _propTypes.string,
  theme: _propTypes.string,
  value: _propTypes.string.isRequired
};
var CheckboxFilter = function CheckboxFilter(props) {
  var handleChange = function handleChange(event) {
    props.onChange(event);
  };
  var name = props.name,
    value = props.value,
    label = props.label,
    _props$subLabel = props.subLabel,
    subLabel = _props$subLabel === void 0 ? "" : _props$subLabel,
    checked = props.checked,
    icon = props.icon,
    inline = props.inline,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? "dark" : _props$theme;
  var inlineClass = inline ? "hl__checkbox-filter--inline" : "";
  var themeClass = theme ? "hl__checkbox-filter--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: "hl__checkbox-filter ".concat(themeClass, " ").concat(inlineClass)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    name: name,
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: handleChange,
    className: "hl__checkbox-filter__label"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__checkbox-filter__container"
  }, icon && !inline && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__icon"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: icon,
    alt: ""
  })), icon && inline && /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: icon,
    className: "hl__checkbox-filter__icon"
  }), subLabel === "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label), subLabel !== "" && /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__checkbox-filter__label"
  }, label, " \u2014 ", /*#__PURE__*/_react["default"].createElement("small", null, subLabel))));
};
CheckboxFilter.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = CheckboxFilter;

},{"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  align: _propTypes.string,
  alt: _propTypes.string,
  src: _propTypes.string.isRequired,
  height: _propTypes.string,
  width: _propTypes.string
};
var Image = function Image(props) {
  var align = props.align,
    alt = props.alt,
    src = props.src,
    height = props.height,
    width = props.width;
  var imageAlign = align ? "hl__image--".concat(align) : "";
  return /*#__PURE__*/_react["default"].createElement("img", {
    className: "hl__image".concat(imageAlign),
    alt: alt,
    src: src,
    height: height,
    width: width
  });
};
Image.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = Image;

},{"prop-types":"prop-types","react":"react"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _checkboxFilter = _interopRequireDefault(require("../../01-atoms/forms/checkbox-filter.jsx"));
var _rangeSlider = _interopRequireDefault(require("../../02-molecules/forms/range-slider.jsx"));
var _weekPicker = _interopRequireDefault(require("../../02-molecules/forms/week-picker.jsx"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FilterGroup = exports["default"] = /*#__PURE__*/function (_Component) {
  function FilterGroup() {
    var _this;
    _classCallCheck(this, FilterGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FilterGroup, [].concat(args));
    _defineProperty(_this, "handleAccordion", function (e) {
      e.preventDefault();
      _this.props.accordionChange(_this.props.param, !_this.props.expanded);
    });
    _defineProperty(_this, "handleSelectChange", function (value) {
      var _this$props = _this.props,
        param = _this$props.param,
        onChange = _this$props.onChange;
      onChange(param, value);
    });
    return _this;
  }
  _inherits(FilterGroup, _Component);
  return _createClass(FilterGroup, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.expanded == nextProps.expanded) {
        return;
      }
      var $content = (0, _jquery["default"])(this.accordionContent);
      if (nextProps.expanded) {
        $content.slideDown();
      } else {
        $content.slideUp();
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this$props2 = this.props,
        _this$props2$assetsUr = _this$props2.assetsUrl,
        assetsUrl = _this$props2$assetsUr === void 0 ? "../.." : _this$props2$assetsUr,
        param = _this$props2.param,
        onChange = _this$props2.onChange,
        filterType = _this$props2.filterType,
        _this$props2$selected = _this$props2.selected,
        selected = _this$props2$selected === void 0 ? [] : _this$props2$selected,
        items = _this$props2.items,
        placeholder = _this$props2.placeholder;
      switch (filterType) {
        case "range_slider":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_rangeSlider["default"], _extends({
              key: param + item.value,
              onChange: onChange
            }, item));
          });
          break;
        case "checkbox":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_checkboxFilter["default"], _extends({
              key: param + item.value,
              onChange: onChange,
              name: param
            }, item));
          });
          break;
        case "inline-checkbox":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_checkboxFilter["default"], _extends({
              key: param + item.value,
              onChange: onChange,
              name: param,
              inline: true
            }, item));
          });
          break;
        case "select":
          return /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
            name: param,
            value: selected,
            multi: true,
            onChange: this.handleSelectChange,
            options: items,
            clearable: false,
            placeholder: placeholder
          });
          break;
        case "keyword":
          return /*#__PURE__*/_react["default"].createElement("input", {
            className: "hl__input",
            name: param,
            id: param,
            type: "text",
            placeholder: placeholder,
            value: items.length && items[0].value ? items[0].value : "",
            onChange: onChange
          });
          break;
        case "weekPicker":
          return items.map(function (item, index) {
            return /*#__PURE__*/_react["default"].createElement(_weekPicker["default"], _extends({
              key: "single_date_".concat(index),
              assetsUrl: assetsUrl,
              onDateChange: onChange
            }, item));
          });
          break;
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        label = _this$props3.label,
        expanded = _this$props3.expanded,
        filterType = _this$props3.filterType,
        hideAccordion = _this$props3.hideAccordion,
        accordionChange = _this$props3.accordionChange,
        param = _this$props3.param;
      var themeClass = filterType === "inline-checkbox" ? "hl__filter-group--inline" : "";
      var filterName = "hl__filter-group--".concat(param);
      return /*#__PURE__*/_react["default"].createElement("fieldset", {
        className: "hl__filter-group ".concat(themeClass, " ").concat(filterName)
      }, !hideAccordion && accordionChange && /*#__PURE__*/_react["default"].createElement("legend", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "hl__filter-group__label",
        type: "button",
        "aria-expanded": expanded,
        onClick: this.handleAccordion
      }, label)), hideAccordion && /*#__PURE__*/_react["default"].createElement("legend", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-group__label"
      }, label)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-group__items",
        ref: function ref(el) {
          return _this2.accordionContent = el;
        }
      }, this.renderFilters()));
    }
  }]);
}(_react.Component);
_defineProperty(FilterGroup, "propTypes", {
  accordionChange: _propTypes.func,
  assetsUrl: _propTypes.string,
  expanded: _propTypes.bool.isRequired,
  filterType: _propTypes.string.isRequired,
  hideAccordion: _propTypes.bool,
  items: _propTypes.array.isRequired,
  label: _propTypes.string.isRequired,
  onChange: _propTypes.func.isRequired,
  param: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  selected: _propTypes.array // for select type
});

},{"../../01-atoms/forms/checkbox-filter.jsx":2,"../../02-molecules/forms/range-slider.jsx":6,"../../02-molecules/forms/week-picker.jsx":7,"jquery":"jquery","prop-types":"prop-types","react":"react","react-select":"react-select"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _filterGroup = _interopRequireDefault(require("./filter-group.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  hideFilters: _propTypes.bool.isRequired,
  message: _propTypes.string,
  groups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    hideAccordion: _propTypes.bool,
    param: _propTypes.string.isRequired,
    expanded: _propTypes.bool.isRequired,
    items: _propTypes.array
  })).isRequired,
  onAccordionChange: _propTypes.func,
  onHideFilters: _propTypes.func.isRequired,
  onClearAll: _propTypes.func.isRequired,
  title: _propTypes.string.isRequired
};
var FilterRail = function FilterRail(props) {
  // if all accordions are collapsed
  // expand all accordions
  // otherwise collapse all accordions
  var handleCollapseAll = function handleCollapseAll(event) {
    var groups = props.groups,
      onAccordionChange = props.onAccordionChange;
    var expandedState = accordionsCollapsed();
    groups.forEach(function (group) {
      onAccordionChange(group.param, expandedState);
    });
  };
  var handleHide = function handleHide(event) {
    props.onHideFilters(!props.hideFilters);
  };
  var accordionsCollapsed = function accordionsCollapsed() {
    return props.groups.every(function (group) {
      return !group.expanded;
    });
  };
  var renderGroups = function renderGroups(groups) {
    var assetsUrl = props.assetsUrl,
      onAccordionChange = props.onAccordionChange;
    return groups.filter(function (group) {
      return group.items && group.items.length;
    }).map(function (group) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__filter-rail__group",
        key: group.param
      }, /*#__PURE__*/_react["default"].createElement(_filterGroup["default"], _extends({
        accordionChange: onAccordionChange,
        assetsUrl: assetsUrl,
        hideAccordion: group.hideAccordion
      }, group)));
    });
  };
  var groups = props.groups,
    hideFilters = props.hideFilters,
    title = props.title,
    onAccordionChange = props.onAccordionChange,
    onClearAll = props.onClearAll,
    assetsUrl = props.assetsUrl,
    message = props.message;
  var expandedClass = hideFilters ? "hl__filter-rail--collapsed" : " ";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-rail ".concat(expandedClass)
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "hl__filter-rail__header"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__filter-rail__title"
  }, title), /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-rail__hide-filters",
    type: "button",
    "aria-label": "Hide/Show Filters",
    "aria-expanded": !hideFilters,
    onClick: handleHide
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__filter-rail__spacer"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: "".concat(assetsUrl, "/assets/images/svg-icons/collapse-icon.svg")
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-rail__header-controls"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-rail__clear-button",
    type: "button",
    "aria-label": "Clear all filters",
    onClick: onClearAll
  }, "Clear All"), onAccordionChange && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-rail__collapse-row"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "hl__filter-rail__collapse-all",
    type: "button",
    "aria-label": "Toggle all filter groups",
    "aria-expanded": !accordionsCollapsed(),
    onClick: handleCollapseAll
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Collapse All"), /*#__PURE__*/_react["default"].createElement("span", null, "Expand All"))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-rail__filters"
  }, renderGroups(groups), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__filter-rail__message"
  }, message)));
};
FilterRail.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = FilterRail;

},{"./filter-group.jsx":4,"prop-types":"prop-types","react":"react"}],6:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactInputRange = _interopRequireDefault(require("react-input-range"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// https://github.com/davidchin/react-input-range

var propTypes = {
  min: _propTypes.number.isRequired,
  max: _propTypes.number.isRequired,
  value: _propTypes.object.isRequired,
  onChange: _propTypes.func.isRequired
};
var RangeSlider = function RangeSlider(props) {
  var min = props.min,
    max = props.max,
    value = props.value,
    onChange = props.onChange;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__range-slider"
  }, /*#__PURE__*/_react["default"].createElement(_reactInputRange["default"], {
    maxValue: max,
    minValue: min,
    value: value,
    onChange: onChange
  }));
};
RangeSlider.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = RangeSlider;

},{"prop-types":"prop-types","react":"react","react-input-range":"react-input-range"}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
var _moment = _interopRequireDefault(require("moment"));
var _propTypes = require("prop-types");
var _reactMomentProptypes = require("react-moment-proptypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } // https://github.com/airbnb/react-dates
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  date: _reactMomentProptypes.momentObj.isRequired,
  focused: _propTypes.bool.isRequired,
  onFocusChange: _propTypes.func.isRequired,
  onDateChange: _propTypes.func.isRequired,
  properties: _propTypes.object,
  // optional settings
  navPrev: _propTypes.node,
  navNext: _propTypes.node
};
var WeekPicker = function WeekPicker(props) {
  var onChange = function onChange(date) {
    if (date.day() !== 0) {
      date.subtract(date.day(), "days");
    }
    props.onDateChange(date);
  };
  var onPreviousWeek = function onPreviousWeek() {
    props.onDateChange(props.date.subtract(7, "days"));
  };
  var onNextWeek = function onNextWeek() {
    props.onDateChange(props.date.add(7, "days"));
  };
  var assetsUrl = props.assetsUrl,
    properties = props.properties,
    focused = props.focused,
    date = props.date,
    onFocusChange = props.onFocusChange;
  var endDate = (0, _moment["default"])(date).add(6, "days").format("MMM DD, YYYY");
  var navPrev = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "9px",
    height: "14px",
    viewBox: "0 0 9 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-733.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    transform: "translate(47.264520, 51.000000) scale(-1, 1) translate(-47.264520, -51.000000) ",
    points: "44.476406 58 51.2020202 51.0008077 44.476406 44 43.3270202 45.9416176 48.1873394 51.0008077 43.3270202 56.0583824"
  })))));
  var navNext = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-960.000000, -834.000000)",
    fill: "#1E1E1E"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(690.000000, 790.000000)"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "271.149386 58 277.875 51.0008077 271.149386 44 270 45.9416176 274.860319 51.0008077 270 56.0583824"
  })))));
  var downArrow = /*#__PURE__*/_react["default"].createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "mask0_4901_183512",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "16",
    height: "16",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#mask0_4901_183512)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.99967 11.7556L3.33301 7.08889L4.4219 6L7.99967 9.57778L11.5775 6L12.6663 7.08889L7.99967 11.7556Z",
    fill: "#A51C30"
  })));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__date-range"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    disabled: date < (0, _moment["default"])(),
    onClick: onPreviousWeek,
    type: "button",
    "aria-label": "Previous week",
    className: "hl__week-picker__control--previous"
  }, navPrev)), /*#__PURE__*/_react["default"].createElement(_reactDates.SingleDatePicker, _extends({
    date: date,
    focused: focused,
    onFocusChange: onFocusChange,
    onDateChange: onChange,
    navPrev: navPrev,
    navNext: navNext,
    showDefaultInputIcon: true,
    inputIconPosition: "after",
    customInputIcon: downArrow
  }, properties)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__to-divider"
  }, "to"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__end-date__group"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hl__week-picker__end-date"
  }, endDate), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__week-picker__control"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onNextWeek,
    type: "button",
    "aria-label": "Next week",
    className: "hl__week-picker__control--next"
  }, navNext)))));
};
WeekPicker.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = WeekPicker;

},{"moment":"moment","prop-types":"prop-types","react":"react","react-dates":"react-dates","react-dates/initialize":"react-dates/initialize","react-moment-proptypes":"react-moment-proptypes"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _illustratedList = _interopRequireDefault(require("../../02-molecules/lists/illustrated-list.jsx"));
var _imageCarousel = _interopRequireDefault(require("../../02-molecules/media/image-carousel.jsx"));
var _libraryAddress = _interopRequireDefault(require("../../02-molecules/text/library-address.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpacesDetail = exports["default"] = /*#__PURE__*/function (_Component) {
  function SpacesDetail() {
    var _this;
    _classCallCheck(this, SpacesDetail);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpacesDetail, [].concat(args));
    _defineProperty(_this, "renderNoise", function (noiseFilters, noiseLevel) {
      var temp = noiseFilters.items.filter(function (n) {
        return n.value === noiseLevel;
      })[0];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__noise-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        className: "hl__spaces-detail__noise-icon",
        src: temp.icon
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__spaces-detail__noise-label"
      }, temp.label));
    });
    _defineProperty(_this, "createFeatures", function (features) {
      return features.map(function (feature) {
        var temp = Object.assign({}, feature);
        if (feature.name) {
          temp.text = feature.name;
        }
        if (feature.icon) {
          temp.icon = {
            src: feature.icon,
            height: "25",
            width: "25"
          };
        } else {
          temp.icon = {};
        }
        return temp;
      });
    });
    return _this;
  }
  _inherits(SpacesDetail, _Component);
  return _createClass(SpacesDetail, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        assetsUrl = _this$props.assetsUrl,
        booking_link = _this$props.booking_link,
        contact = _this$props.contact,
        description = _this$props.description,
        features = _this$props.features,
        floor = _this$props.floor,
        images = _this$props.images,
        library = _this$props.library,
        name = _this$props.name,
        noise = _this$props.noise,
        noise_level = _this$props.noise_level,
        open_space = _this$props.open_space,
        room_type = _this$props.room_type,
        seats = _this$props.seats,
        what_you_need_to_know = _this$props.what_you_need_to_know;
      var hideSeats = open_space || !seats;
      var button = {
        href: booking_link,
        info: "reserve this room",
        text: "Reserve",
        type: "button",
        theme: "secondary"
      };
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__spaces-detail"
      }, /*#__PURE__*/_react["default"].createElement("header", null, images && images.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__images"
      }, /*#__PURE__*/_react["default"].createElement(_imageCarousel["default"], {
        images: images
      })), /*#__PURE__*/_react["default"].createElement("h2", {
        className: "hl__spaces-detail__title"
      }, name, " \u2014 ", floor), hideSeats && /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__sub-title"
      }, room_type), !hideSeats && /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__sub-title"
      }, room_type, " \u2014 ", seats, " seats"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__description"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__rich-text",
        dangerouslySetInnerHTML: {
          __html: description
        }
      }))), noise_level && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__noise"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__section-title"
      }, "Noise Level"), this.renderNoise(noise, noise_level)), features && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__features"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__section-title"
      }, "Features"), /*#__PURE__*/_react["default"].createElement(_illustratedList["default"], {
        theme: "small",
        items: this.createFeatures(features)
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__booking"
      }, (contact || booking_link) && /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__section-title"
      }, "Interested in Booking this Space?"), booking_link && /*#__PURE__*/_react["default"].createElement(_button["default"], button), !booking_link && contact && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__booking-email"
      }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        src: "".concat(assetsUrl, "/assets/images/svg-icons/email.svg"),
        className: "hl__spaces-detail__booking-icon"
      }), /*#__PURE__*/_react["default"].createElement("a", {
        className: "hl__link-tag",
        href: "mailto:".concat(contact)
      }, contact))), what_you_need_to_know && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__additional-info"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "hl__spaces-detail__section-title"
      }, "What you need to know"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__rich-text",
        dangerouslySetInnerHTML: {
          __html: what_you_need_to_know
        }
      })), library && /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-detail__library"
      }, /*#__PURE__*/_react["default"].createElement(_libraryAddress["default"], _extends({
        assetsUrl: assetsUrl
      }, library))));
    }
  }]);
}(_react.Component);
_defineProperty(SpacesDetail, "propTypes", {
  assetsUrl: _propTypes.string.isRequired,
  booking_link: _propTypes.string,
  contact: _propTypes.string,
  description: _propTypes.string,
  features: _propTypes.array,
  floor: _propTypes.string,
  images: _propTypes.array,
  library: _propTypes.object,
  name: _propTypes.string,
  noise: (0, _propTypes.shape)({
    items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      value: _propTypes.string
    }))
  }),
  noise_level: _propTypes.string,
  open_space: _propTypes.bool,
  room_type: _propTypes.string,
  seats: _propTypes.string,
  what_you_need_to_know: _propTypes.string
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/lists/illustrated-list.jsx":9,"../../02-molecules/media/image-carousel.jsx":10,"../../02-molecules/text/library-address.jsx":12,"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _image = _interopRequireDefault(require("../../01-atoms/media/image.jsx"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    text: _propTypes.string.isRequired,
    icon: _propTypes.shape
  })).isRequired,
  theme: _propTypes.string
};
var IllustratedList = function IllustratedList(props) {
  var renderItems = function renderItems(items) {
    return items.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__illustrated-list__list-item",
        key: item.text.replace(/\s/g, "")
      }, item.icon && /*#__PURE__*/_react["default"].createElement("span", {
        className: "hl__illustrated-list__image-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_image["default"], item.icon)), /*#__PURE__*/_react["default"].createElement("span", null, item.text));
    });
  };
  var theme = props.theme,
    items = props.items;
  var themeClass = theme ? "hl__illustrated-list--".concat(theme) : "";
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "hl__illustrated-list ".concat(themeClass)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__illustrated-list__featured-items"
  }, renderItems(items)));
};
IllustratedList.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = IllustratedList;

},{"../../01-atoms/media/image.jsx":3,"prop-types":"prop-types","react":"react"}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ImageCarousel = exports["default"] = /*#__PURE__*/function (_Component) {
  function ImageCarousel() {
    var _this;
    _classCallCheck(this, ImageCarousel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ImageCarousel, [].concat(args));
    _defineProperty(_this, "renderImages", function (images) {
      var isSlider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return images.map(function (image, i) {
        var style = {
          backgroundImage: "url(\"".concat(image.src, "\")")
        };
        if (isSlider) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: image.src,
            className: "hl__image-carousel__image-wrapper"
          }, /*#__PURE__*/_react["default"].createElement("div", {
            className: "hl__image-carousel__image",
            style: style
          }));
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: image.src,
          className: "hl__image-carousel__image",
          style: style
        });
      });
    });
    return _this;
  }
  _inherits(ImageCarousel, _Component);
  return _createClass(ImageCarousel, [{
    key: "render",
    value: function render() {
      var images = this.props.images;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__image-carousel"
      }, images.length > 1 && /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], {
        className: "hl__image-carousel__slider"
      }, this.renderImages(images, true)), images.length == 1 && this.renderImages(images));
    }
  }]);
}(_react.Component);
_defineProperty(ImageCarousel, "propTypes", {
  images: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    src: _propTypes.string.isRequired
  })).isRequired
});

},{"prop-types":"prop-types","react":"react","react-slick":"react-slick"}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _image = _interopRequireDefault(require("../../01-atoms/media/image.jsx"));
var _illustratedList = _interopRequireDefault(require("../../02-molecules/lists/illustrated-list.jsx"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  id: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  floor: _propTypes.string.isRequired,
  room_type: _propTypes.string,
  library: (0, _propTypes.shape)({
    name: _propTypes.string.isRequired
  }).isRequired,
  image: _propTypes.object.isRequired,
  features: _propTypes.array,
  building_name: _propTypes.string,
  handleClick: _propTypes.func.isRequired,
  assetsUrl: _propTypes.string.isRequired
};
var SpaceTeaser = function SpaceTeaser(props) {
  var createFeatures = function createFeatures(features) {
    return features.map(function (feature) {
      var temp = Object.assign({}, feature);
      if (feature.name) {
        temp.text = feature.name;
      }
      if (feature.icon) {
        temp.icon = {
          src: feature.icon,
          height: "25",
          width: "25"
        };
      } else {
        temp.icon = {};
      }
      return temp;
    });
  };
  var handleClick = function handleClick(e) {
    e.preventDefault();
    props.handleClick(props.id);
  };
  var assetsUrl = props.assetsUrl,
    name = props.name,
    floor = props.floor,
    room_type = props.room_type,
    image = props.image,
    features = props.features,
    library = props.library;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: "#",
    className: "hl__space-teaser",
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__space-teaser__title"
  }, name, " \u2014 ", floor), room_type && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__space-teaser__type"
  }, room_type), library.name && library.address && library.address.building_name && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__space-teaser__building"
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: "".concat(assetsUrl, "/assets/images/svg-icons/map-marker.svg"),
    className: "hl__space-teaser__location-icon"
  }), /*#__PURE__*/_react["default"].createElement("span", null, library.name, " in ", library.address.building_name)), image && image.src && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__space-teaser__image"
  }, /*#__PURE__*/_react["default"].createElement(_image["default"], image)), features.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__space-teaser__features"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "hl__space-teaser__feature-title"
  }, "Features"), /*#__PURE__*/_react["default"].createElement(_illustratedList["default"], {
    items: createFeatures(features).slice(0, 4),
    theme: "small"
  })));
};
SpaceTeaser.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = SpaceTeaser;

},{"../../01-atoms/media/image.jsx":3,"../../02-molecules/lists/illustrated-list.jsx":9,"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _currentDate = _interopRequireDefault(require("../../../js/helpers/currentDate.js"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var propTypes = {
  assetsUrl: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  coordinates: (0, _propTypes.shape)({
    latitude: _propTypes.number,
    longitude: _propTypes.number
  }),
  address: (0, _propTypes.shape)({
    address_line1: _propTypes.string.isRequired,
    address_line2: _propTypes.string,
    administrative_area: _propTypes.string.isRequired,
    locality: _propTypes.string.isRequired,
    organization: _propTypes.string,
    postal_code: _propTypes.string.isRequired
  }).isRequired,
  times: (0, _propTypes.shape)({
    rendered: _propTypes.string.isRequired
  }).isRequired
};
var LibraryAddress = function LibraryAddress(props) {
  var assetsUrl = props.assetsUrl,
    name = props.name,
    href = props.href,
    coordinates = props.coordinates,
    times = props.times,
    address = props.address;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    className: "hl__library-address__title"
  }, name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address__hours"
  }, /*#__PURE__*/_react["default"].createElement("mark", {
    className: "hl__library-address__current-date"
  }, (0, _currentDate["default"])()), times.rendered), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address__address"
  }, /*#__PURE__*/_react["default"].createElement("div", null, address.organization ? "".concat(address.organization, ", ") : "", address.address_line1), address.address_line2 && /*#__PURE__*/_react["default"].createElement("div", null, address.address_line2), /*#__PURE__*/_react["default"].createElement("div", null, address.locality, ", ", address.administrative_area, " ", address.postal_code)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address__links"
  }, coordinates && coordinates.latitude && coordinates.longitude && /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address__link"
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: "".concat(assetsUrl, "/assets/images/svg-icons/map-marker.svg"),
    className: "hl__library-address__icon"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__library-address__directions",
    href: "https://www.google.com/maps/dir/?api=1&destination=".concat(coordinates.latitude, ",").concat(coordinates.longitude)
  }, "Directions")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "hl__library-address__link"
  }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    src: "".concat(assetsUrl, "/assets/images/svg-icons/web-link.svg"),
    className: "hl__library-address__icon"
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "hl__library-address__detail-page",
    href: href
  }, "More about ", name))));
};
LibraryAddress.propTypes = propTypes; // defined at the top of the file
var _default = exports["default"] = LibraryAddress;

},{"../../../js/helpers/currentDate.js":17,"prop-types":"prop-types","react":"react","react-inlinesvg":"react-inlinesvg"}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _spaceTeaser = _interopRequireDefault(require("../../02-molecules/teasers/space-teaser.jsx"));
var _spacesDetail = _interopRequireDefault(require("../../02-molecules/general/spaces-detail.jsx"));
var _button = _interopRequireDefault(require("../../01-atoms/buttons/button.jsx"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpacesResults = exports["default"] = /*#__PURE__*/function (_Component) {
  function SpacesResults() {
    var _this;
    _classCallCheck(this, SpacesResults);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpacesResults, [].concat(args));
    _defineProperty(_this, "renderItems", function (items) {
      if (items.length === 0) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "hl__spaces-results__no-results"
        }, "No Results Found.");
      }
      return items.map(function (item) {
        var keyValue = "".concat(item.name, "-").concat(item.floor).replace(/\s/g, "");
        var image = item.images[0] || {};
        return /*#__PURE__*/_react["default"].createElement(_spaceTeaser["default"], _extends({
          key: keyValue,
          image: image,
          assetsUrl: _this.props.assetsUrl,
          handleClick: _this.props.handleResultClick
        }, item));
      });
    });
    _defineProperty(_this, "onCloseDetail", function (e) {
      e.preventDefault();
      _this.closeLink.blur();
      _this.props.handleCloseDetail();
    });
    return _this;
  }
  _inherits(SpacesResults, _Component);
  return _createClass(SpacesResults, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (this.props.items.length > 0) {
        var scrollIndex = this.props.items.length > 10 ? Math.floor((this.props.items.length - 1) / 10) * 10 : 0;
        var scrollPos = (0, _jquery["default"])(".hl__spaces-results__items").scrollTop() + (0, _jquery["default"])(".hl__space-teaser").eq(scrollIndex).position().top;
        (0, _jquery["default"])(".hl__spaces-results__items").stop(true, true).animate({
          scrollTop: scrollPos
        }, '750');
      }
      if (this.props.showDetails) {
        window.setTimeout(function () {
          _this2.closeLink.focus();
          window.dispatchEvent(new Event("resize")); // fixes carousel width
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        assetsUrl = _this$props.assetsUrl,
        items = _this$props.items,
        totalCount = _this$props.totalCount,
        showDetails = _this$props.showDetails,
        noise = _this$props.noise,
        activeSpace = _this$props.activeSpace,
        handleLoadMore = _this$props.handleLoadMore;
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__spaces-results"
      }, totalCount === items.length && /*#__PURE__*/_react["default"].createElement("header", {
        className: "hl__spaces-results__header",
        "aria-hidden": showDetails
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-results__count"
      }, "Showing ", /*#__PURE__*/_react["default"].createElement("span", null, totalCount), " spaces")), totalCount > items.length && /*#__PURE__*/_react["default"].createElement("header", {
        className: "hl__spaces-results__header",
        "aria-hidden": showDetails
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-results__load-more"
      }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
        text: "Load More",
        info: "load more rooms",
        size: "small",
        type: "button",
        handleClick: handleLoadMore
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-results__items",
        "aria-hidden": showDetails
      }, this.renderItems(items)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-results__detail",
        id: "hl__spaces-results__detail",
        "aria-hidden": !showDetails,
        ref: function ref(el) {
          _this3.detailDiv = el;
        }
      }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "hl__spaces-results__close-detail",
        type: "button",
        onClick: this.onCloseDetail,
        ref: function ref(el) {
          _this3.closeLink = el;
        }
      }, "close")), activeSpace.name && /*#__PURE__*/_react["default"].createElement(_spacesDetail["default"], _extends({
        noise: noise,
        assetsUrl: assetsUrl
      }, activeSpace))));
    }
  }]);
}(_react.Component);
_defineProperty(SpacesResults, "propTypes", {
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    floor: _propTypes.string.isRequired
  })).isRequired,
  totalCount: _propTypes.number.isRequired,
  activeSpace: _propTypes.object.isRequired,
  assetsUrl: _propTypes.string.isRequired,
  noise: _propTypes.object.isRequired,
  showDetails: _propTypes.bool.isRequired,
  handleCloseDetail: _propTypes.func.isRequired,
  handleLoadMore: _propTypes.func.isRequired,
  handleResultClick: _propTypes.func.isRequired
});

},{"../../01-atoms/buttons/button.jsx":1,"../../02-molecules/general/spaces-detail.jsx":8,"../../02-molecules/teasers/space-teaser.jsx":11,"jquery":"jquery","prop-types":"prop-types","react":"react"}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ramda = _interopRequireDefault(require("ramda"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpacesMap = exports["default"] = /*#__PURE__*/function (_Component) {
  function SpacesMap(props) {
    var _this;
    _classCallCheck(this, SpacesMap);
    _this = _callSuper(this, SpacesMap, [props]);
    _defineProperty(_this, "loadGoogleJS", function () {
      window.initGoogleMap = function () {
        _this.googleMap = window.google.maps;
        _this.markerIcon = {
          url: "".concat(_this.props.assetsUrl, "/assets/images/spaces-marker.png"),
          size: new _this.googleMap.Size(22, 27),
          origin: new _this.googleMap.Point(0, 0),
          anchor: new _this.googleMap.Point(0, 32),
          labelOrigin: new _this.googleMap.Point(11, 13)
        };
        _this.renderMap();
      };
      var script = document.createElement("script");
      var googleMapsApiKey = _this.props.googleMapsApiKey;
      script.type = "text/javascript";
      script.src = "//maps.googleapis.com/maps/api/js?key=".concat(googleMapsApiKey, "&callback=initGoogleMap");
      document.getElementsByTagName("head")[0].appendChild(script);
    });
    _defineProperty(_this, "renderMap", function () {
      var styledMapType = new _this.googleMap.StyledMapType(_this.mapTheme, {
        name: "Map"
      });

      // Create a map object, and include the MapTypeId to add
      // to the map type control.
      _this.map = new _this.googleMap.Map(_this.mapDiv, {
        center: {
          lat: 42.377252,
          lng: -71.116653
        },
        zoom: 18,
        mapTypeControlOptions: {
          mapTypeIds: ["styled_map", "satellite"]
        }
      });

      //Associate the styled map with the MapTypeId and set it to display.
      _this.map.mapTypes.set("styled_map", styledMapType);
      _this.map.setMapTypeId("styled_map");
      _this.updateMap(_this.props.markers);
    });
    _defineProperty(_this, "updateMap", function (data) {
      // remove existing markers
      _ramda["default"].forEachObjIndexed(function (marker) {
        marker.setMap(null);
      }, _this.markers);
      _this.markers = {};

      // exit if the map hasn't been created
      if (_this.map === null || !data) {
        // exit here
        return;
      }
      _ramda["default"].forEachObjIndexed(function (value, libId) {
        if (!value.coordinates.lat || !value.coordinates.lng) {
          // Harvard University Coordinates found in Google Maps
          value.coordinates.lat = 42.374276;
          value.coordinates.lng = -71.116240;
        }
        var infoWindowContent = _this.createInfoWindow(value);
        var markerData = {
          position: new _this.googleMap.LatLng(value.coordinates),
          label: {
            text: value.items.length >= 1 ? "".concat(value.items.length) : " ",
            // the space is required
            color: "white"
          },
          icon: _this.markerIcon,
          title: value.name,
          map: _this.map
        };
        _this.markers[libId] = new _this.googleMap.Marker(markerData);
        _this.markers[libId].addListener("click", function (e) {
          if (_this.infowindow) {
            _this.infowindow.close();
          }
          _this.infowindow = new _this.googleMap.InfoWindow({
            content: infoWindowContent
          });
          // show this info window
          _this.infowindow.open(_this.map, _this.markers[libId]);
        });
        _this.centerMap();
      }, data);
    });
    _defineProperty(_this, "createInfoWindow", function (data) {
      if (data.items.length > 1) {
        var template = data.items.map(function (item) {
          return "\n          <li class=\"hl__spaces-info-window__item\">\n            <a href=\"#\" class=\"hl__spaces-info-window__link js-spaces-info-window-link\" data-id=".concat(item.id, ">\n              ").concat(item.name, " &mdash; ").concat(item.floor, "\n            </a>\n          </li>\n        ");
        }).join("\n");

        // return the list view
        return "\n        <section class=\"hl__spaces-info-window\">\n          <h2 class=\"hl__spaces-info-window__title\">\n            ".concat(data.name, "\n          </h2>\n          <ul class=\"hl__spaces-info-window__items\">\n            ").concat(template, "\n          </ul>\n        </section>\n      ");
      } else {
        var item = data.items[0];
        var features = item.features.map(function (feature) {
          return "\n          <li class=\"hl__spaces-info-window__feature\">\n            <img src=".concat(feature.icon, " alt=").concat(feature.name, " title=").concat(feature.name, " height=\"25\" width=\"25\" />\n          </li>\n        ");
        }).join("\n");
        // return the single view
        return "\n        <section class=\"hl__spaces-info-window\">\n          <h2 class=\"hl__spaces-info-window__title\">\n            <a href=\"#\" class=\"hl__spaces-info-window__link js-spaces-info-window-link\" data-id=".concat(item.id, ">\n              ").concat(item.name, " &mdash; ").concat(item.floor, "\n            </a>\n          </h2>\n          <p class=\"hl__spaces-info-window__description\">\n            ").concat(item.description, "\n          </p>\n          <ul class=\"hl__spaces-info-window__features\">\n            ").concat(features, "\n          </ul>\n        </section>\n      ");
      }
    });
    _defineProperty(_this, "centerMap", function () {
      // reset the zoom to show all markers
      var bounds = new _this.googleMap.LatLngBounds();
      _ramda["default"].forEachObjIndexed(function (marker) {
        bounds.extend(marker.getPosition());
      }, _this.markers);
      _this.map.fitBounds(bounds);

      // set a minimum zoom
      // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
      if (_this.map.getZoom() > 18) {
        _this.map.setZoom(18);
      }
    });
    _this.map = null;
    _this.markers = {};
    _this.infoWindow = null;
    _this.markerIcon = {};

    //https://snazzymaps.com/style/83/muted-blue
    _this.mapTheme = [{
      "featureType": "all",
      "stylers": [{
        "saturation": 0
      }, {
        "hue": "#e7ecf0"
      }]
    }, {
      "featureType": "road",
      "stylers": [{
        "saturation": -70
      }]
    }, {
      "featureType": "transit",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "poi",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "water",
      "stylers": [{
        "visibility": "simplified"
      }, {
        "saturation": -60
      }]
    }];
    return _this;
  }
  _inherits(SpacesMap, _Component);
  return _createClass(SpacesMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.loadGoogleJS();
      window.addEventListener("resize", this.centerMap);
      this.mapDiv.addEventListener("click", function (event) {
        if (event.target.classList.contains("js-spaces-info-window-link")) {
          _this2.props.handleInfoClick(event.target.getAttribute("data-id").toString());
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mapDiv.removeEventListener("click");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateMap(this.props.markers);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__spaces-map",
        ref: function ref(el) {
          return _this3.mapDiv = el;
        }
      }, "Loading Google Maps");
    }
  }]);
}(_react.Component);
_defineProperty(SpacesMap, "propTypes", {
  markers: _propTypes.object,
  assetsUrl: _propTypes.string.isRequired,
  handleInfoClick: _propTypes.func.isRequired,
  googleMapsApiKey: _propTypes.string.isRequired
});

},{"prop-types":"prop-types","ramda":"ramda","react":"react"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _jquery = _interopRequireDefault(require("jquery"));
var _react = _interopRequireWildcard(require("react"));
var _ramda = _interopRequireDefault(require("ramda"));
var _queryString = _interopRequireDefault(require("query-string"));
var _filterRail = _interopRequireDefault(require("../../02-molecules/forms/filter-rail.jsx"));
var _spacesResults = _interopRequireDefault(require("../../03-organisms/general/spaces-results.jsx"));
var _spacesMap = _interopRequireDefault(require("../../03-organisms/media/spaces-map.jsx"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpaceFinderApp = exports["default"] = /*#__PURE__*/function (_Component) {
  function SpaceFinderApp(props) {
    var _this;
    _classCallCheck(this, SpaceFinderApp);
    _this = _callSuper(this, SpaceFinderApp, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      // fetch all features
      var getFeatures = _this.fetchFeatures();
      // fetch all room types
      var getRoomTypes = _this.fetchRoomTypes();
      // fetch all building types
      var getBuildings = _this.fetchBuildings().then(function (data) {
        var filters = data.map(function (library) {
          return {
            label: library.name,
            value: library.id,
            checked: false
          };
        });
        if (filters.length === 1) {
          filters[0].checked = true;
        }
        return {
          filters: filters,
          buildings: data
        };
      });
      Promise.all([getRoomTypes, getFeatures, getBuildings]).then(function (values) {
        var filters = Object.assign({}, _this.state.filters);
        filters.roomTypes.items = filters.roomTypes.items.concat(values[0]);
        filters.features.items = filters.features.items.concat(values[1]);
        filters.buildings.items = filters.buildings.items.concat(values[2].filters);

        // hide the filters on narrow screens (max-width: 620px)
        var hideFilters = document.documentElement.clientWidth <= 620;

        // mark filters found in the URL
        filters = _this.initializeFilters(filters);

        // update state and render filters
        _this.setState({
          filters: filters,
          buildings: values[2].buildings,
          hideFilters: hideFilters
        });

        // fetch results for filters in params
        _this.fetchResults(filters);
      });
    });
    // ******* Gather Data **************** //
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchRoomTypes", function () {
      return fetch("".concat(_this.props.baseRequestUrl, "/api/v1/taxonomy/room_types?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.map(function (roomType) {
          roomType.value = roomType.tid;
          roomType.checked = false;
          return roomType;
        });
      })["catch"](function (error) {
        console.warn("failed to fetch room types:", error);
        return [];
      });
    });
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchFeatures", function () {
      return fetch("".concat(_this.props.baseRequestUrl, "/api/v1/taxonomy/amenities?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.filter(function (feature) {
          feature.value = feature.tid;
          feature.checked = false;
          feature.excludeFromSpacefinder = feature.excludeFromSpacefinder === "0" ? false : feature.excludeFromSpacefinder;
          feature.excludeFromSpacefinder = feature.excludeFromSpacefinder === "1" ? true : feature.excludeFromSpacefinder;
          return !feature.excludeFromSpacefinder;
        });
      })["catch"](function (error) {
        console.warn("failed to fetch features:", error);
        return [];
      });
    });
    // returns an array of properly formated filters
    _defineProperty(_this, "fetchBuildings", function () {
      return fetch("".concat(_this.props.baseRequestUrl, "/api/v1/library/rooms?_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data;
      })["catch"](function (error) {
        console.warn("failed to fetch libraries:", error);
        return [];
      });
    });
    // returns a specific room
    _defineProperty(_this, "fetchRoom", function (id) {
      return fetch("".concat(_this.props.baseRequestUrl, "/api/v1/rooms?id=").concat(id, "&_format=json")).then(function (response) {
        return response.json();
      }).then(function (data) {
        return data.results && data.results.items ? data.results.items[0] : null;
      })["catch"](function (error) {
        console.warn("failed to fetch room:", error);
        return null;
      });
    });
    // fetches results from the api based on the filter values passed
    // optional loadMore boolean is used to append or replace the existing results
    _defineProperty(_this, "fetchResults", function (filters) {
      var loadMore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (loadMore) {
        _this.currentPage++;
      } else {
        _this.currentPage = 0;
      }
      var activeFilters = Object.assign({
        page: _this.currentPage,
        _format: "json"
      }, _this.queryString);
      if (activeFilters.seats_min || activeFilters.seats_max) {
        activeFilters.number_seats = {};
      }
      if (activeFilters.seats_min) {
        activeFilters.number_seats.min = activeFilters.seats_min;
      }
      if (activeFilters.seats_max) {
        activeFilters.number_seats.max = activeFilters.seats_max;
      }
      _this.$ajaxResults.abort();
      _this.$ajaxResults = _jquery["default"].ajax({
        url: "".concat(_this.props.baseRequestUrl, "/api/v1/rooms"),
        data: activeFilters
      });
      _this.$ajaxResults.done(function (data) {
        var currentResults = _this.state.results;
        var mapResults = null;
        var newResults = {
          totalCount: data.results.totalCount || 0,
          items: []
        };
        if (typeof data.results.items === "undefined" || data.results.items.length === 0) {
          if (!loadMore) {
            _this.setState({
              results: newResults,
              mapResults: mapResults
            });
          }
          return;
        }
        var newItems = _this.parseResultItems(data.results.items);
        if (loadMore) {
          newResults.items = currentResults.items.concat(newItems);
        } else {
          newResults.items = newItems;
        }
        mapResults = _this.createMarkers(newResults.items);
        _this.setState({
          results: newResults,
          mapResults: mapResults
        });

        // if a specific room is requested fetch that and update views.
        if (_this.queryString.room) {
          _this.fetchRoom(_this.queryString.room).then(function (data) {
            if (data === null) {
              return;
            }
            var activeSpace = _this.parseResultItems([data])[0];
            var mapResults = _this.createMarkers([activeSpace]);
            _this.setState({
              activeSpace: activeSpace,
              mapResults: mapResults,
              showDetails: true,
              showResults: true,
              showMap: false
            });
          });
        }
      }).fail(function (xhr, status, error) {
        console.warn("failed to fetch results");
        var _this$state = _this.state,
          results = _this$state.results,
          mapResults = _this$state.mapResults;
        results.totalCount = 0;
        results.items = [];
        mapResults = null;
        _this.setState({
          results: results,
          mapResults: mapResults,
          showDetails: false
        });
      });
    });
    // ******* End Gather Data **************** //
    // ******* Data Manipulation **************** //
    // expects an array of results from the api
    // returns a clean array with the proper structure
    _defineProperty(_this, "parseResultItems", function (data) {
      var buildings = _this.state.buildings;
      return data.map(function (result) {
        result.library = _ramda["default"].find(_ramda["default"].propEq(result.library, "id"))(buildings);
        result.images = result.images.map(function (image) {
          return {
            src: image
          };
        });
        return result;
      });
    });
    // takes an array of room objects
    _defineProperty(_this, "createMarkers", function (data) {
      // group items by library id value
      var groupByLibrary = _ramda["default"].groupBy(function (item) {
        return item.library.id || "1";
      });
      var markers = {};
      _ramda["default"].forEachObjIndexed(function (value, libId) {
        markers[libId] = {
          coordinates: {
            lat: value[0].coordinates.latitude,
            lng: value[0].coordinates.longitude
          },
          items: value,
          name: value[0].library.name
        };
      }, groupByLibrary(data));
      return markers;
    });
    // takes a string value of the spaces id
    // returns the first object that matches
    _defineProperty(_this, "createSpaceDetail", function (spaceId) {
      var results = _this.state.results;
      return results.items.find(function (result) {
        return result.id === spaceId;
      });
    });
    _defineProperty(_this, "initializeFilters", function (filters) {
      var params = _this.queryString;
      var maxSeatsAllowed = filters.seats.items[0].max;
      var minSeatsAllowed = filters.seats.items[0].min;
      if (params.features && filters.features.items.length) {
        if (typeof params.features === "string") {
          params.features = [params.features];
        }
        filters.features.items = markItem(params.features, filters.features.items);
      }
      if (params.library && filters.buildings.items.length) {
        if (typeof params.library === "string") {
          params.library = [params.library];
        }
        filters.buildings.items = markItem(params.library, filters.buildings.items);
      }
      if (params.noise_level && filters.noise.items.length) {
        if (typeof params.noise_level === "string") {
          params.noise_level = [params.noise_level];
        }
        filters.noise.items = markItem(params.noise_level, filters.noise.items);
      }
      if (params.room_type && filters.roomTypes.items.length) {
        if (typeof params.room_type === "string") {
          params.room_type = [params.room_type];
        }
        filters.roomTypes.items = markItem(params.room_type, filters.roomTypes.items);
      }
      if (params.seats_min) {
        var minSeats = parseInt(params.seats_min);
        filters.seats.items[0].value.min = minSeats < minSeatsAllowed ? minSeatsAllowed : minSeats > maxSeatsAllowed ? maxSeatsAllowed : minSeats;
      }
      if (params.seats_max) {
        var maxSeats = parseInt(params.seats_max);
        filters.seats.items[0].value.max = maxSeats < minSeatsAllowed ? minSeatsAllowed : maxSeats > maxSeatsAllowed ? maxSeatsAllowed : maxSeats;
      }
      return filters;
      function markItem(param, filterItems) {
        param.forEach(function (paramValue) {
          var filterIndex = filterItems.findIndex(function (item) {
            return item.value === paramValue;
          });
          if (filterItems[filterIndex]) {
            filterItems[filterIndex].checked = true;
          }
        });
        return filterItems;
      }
    });
    // ******* End Data Manipulation **************** //
    // ******* Action Handlers **************** //
    // when an filter accordion expands or collapses
    // receives the key value of the filter and a boolean state
    _defineProperty(_this, "onAccordionChange", function (filterName, value) {
      var filters = Object.assign({}, _this.state.filters);
      for (var filterObj in filters) {
        if (filterName === filters[filterObj].param) {
          filters[filterObj].expanded = value;
          break;
        }
      }
      _this.setState({
        filters: filters
      });
    });
    // when the clear all button is clicked
    // receives the event from the button
    _defineProperty(_this, "onClearAll", function (event) {
      event.preventDefault();
      var filters = Object.assign({}, _this.state.filters);
      // reset each group
      filters.roomTypes.items = filters.roomTypes.items.map(function (item) {
        return _ramda["default"].mergeRight(item, {
          checked: false
        });
      });
      filters.noise.items = filters.noise.items.map(function (item) {
        return _ramda["default"].mergeRight(item, {
          checked: false
        });
      });
      filters.features.items = filters.features.items.map(function (item) {
        return _ramda["default"].mergeRight(item, {
          checked: false
        });
      });
      filters.buildings.items = filters.buildings.items.map(function (item) {
        return _ramda["default"].mergeRight(item, {
          checked: false
        });
      });
      filters.seats.items[0].value.min = filters.seats.items[0].min;
      filters.seats.items[0].value.max = filters.seats.items[0].max;

      // clear the parameters in the url
      _this.queryString = {};
      _this.updateUrl();
      _this.fetchResults(filters);
      _this.setState({
        filters: filters
      });
    });
    // when a filter is clicked
    // recieves the event from the checkbox
    _defineProperty(_this, "onFilterChange", function (event) {
      // loops through the array looking for the checked property as true
      var allCheckedValues = _ramda["default"].compose(_ramda["default"].map(_ramda["default"].prop("value")), _ramda["default"].filter(_ramda["default"].prop("checked")));
      var filterValue = event.target.value;
      var filterName = event.target.name;
      var filters = Object.assign({}, _this.state.filters);
      for (var filterObj in filters) {
        if (filterName === filters[filterObj].param) {
          var filterIndex = filters[filterObj].items.findIndex(function (item) {
            return item.value === filterValue;
          });
          filters[filterObj].items[filterIndex].checked = !filters[filterObj].items[filterIndex].checked;
          _this.updateUrl(filters[filterObj].param, allCheckedValues(filters[filterObj].items));

          // fetch new results
          _this.fetchResults(filters);

          // update the state of the filters
          _this.setState({
            filters: filters
          });
          break;
        }
      }
    });
    // when the user closes the room detail or expands the filters
    // hide the detail and repopulate the map
    _defineProperty(_this, "onHideDetail", function () {
      var results = _this.state.results;
      var mapResults = _this.createMarkers(results.items);
      _this.updateUrl("room", null);
      _this.setState({
        mapResults: mapResults,
        showDetails: false
      });
    });
    // When the user clicks the >> or << button to show or hide the filters
    // receives the desired state as a boolean
    // true == hidden
    // false == visible
    _defineProperty(_this, "onHideFilters", function (value) {
      _this.setState({
        hideFilters: value
      });
      if (_this.state.showDetails) {
        _this.onHideDetail();
      }
    });
    // When a user clicks on a result
    // links in Result list and the Map
    // recieves the id of the room
    _defineProperty(_this, "onResultClick", function (id) {
      var activeSpace = _this.createSpaceDetail(id);
      var mapResults = _this.createMarkers([activeSpace]);
      _this.updateUrl("room", id);
      _this.setState({
        activeSpace: activeSpace,
        mapResults: mapResults,
        showDetails: true,
        showResults: true,
        showMap: false
      });
    });
    // When the user changes the range slider
    // receives an object with the desired values
    // min
    // max
    _defineProperty(_this, "onSeatChange", function (values) {
      var filters = Object.assign({}, _this.state.filters);
      var item = filters.seats.items[0];
      var maxSeatsAllowed = filters.seats.items[0].max;
      var minSeatsAllowed = filters.seats.items[0].min;

      // plugin allows keyboard navigation beyond the min and max scope
      // ignore these values
      if (values.min < item.min || values.max > item.max) {
        return false;
      }
      filters.seats.items[0].value.min = values.min;
      filters.seats.items[0].value.max = values.max;
      _this.queryString.seats_min = values.min === minSeatsAllowed ? "0" : values.min;
      _this.queryString.seats_max = values.max === maxSeatsAllowed ? "1000" : values.max;
      _this.updateUrl();
      _this.fetchResults(filters);
      _this.setState({
        filters: filters
      });
    });
    _defineProperty(_this, "onShowMore", function (event) {
      event.preventDefault();
      _this.fetchResults(_this.state.filters, true);
    });
    _defineProperty(_this, "onTabChange", function (tab) {
      if (tab === "list") {
        _this.setState({
          showMap: false,
          showResults: true
        });
      }
      if (tab === "map") {
        _this.setState({
          showMap: true,
          showResults: false
        });
      }
      // if(this.state.showDetails) {
      //   this.onHideDetail();
      // }
    });
    _this.state = {
      results: {
        totalCount: 0,
        items: []
      },
      mapResults: {},
      activeSpace: {},
      hideFilters: false,
      showDetails: false,
      showMap: true,
      showResults: false,
      filters: {
        roomTypes: {
          label: "Space Type",
          category: "room_types",
          param: "room_type",
          expanded: true,
          filterType: "checkbox",
          onChange: _this.onFilterChange,
          items: []
        },
        noise: {
          label: "Noise Level",
          category: "noise_level",
          param: "noise_level",
          expanded: true,
          filterType: "inline-checkbox",
          onChange: _this.onFilterChange,
          items: [{
            label: "Silent",
            checked: false,
            value: "0",
            icon: "".concat(_this.props.baseAssetsUrl, "/assets/images/svg-icons/noise-silent.svg")
          }, {
            label: "Whispers",
            checked: false,
            value: "1",
            icon: "".concat(_this.props.baseAssetsUrl, "/assets/images/svg-icons/noise-whisper.svg")
          }, {
            label: "Chatter",
            checked: false,
            value: "2",
            icon: "".concat(_this.props.baseAssetsUrl, "/assets/images/svg-icons/noise-chatter.svg")
          }]
        },
        seats: {
          label: "Number of Seats",
          category: "number_seats",
          param: "number_seats",
          expanded: true,
          filterType: "range_slider",
          onChange: _this.onSeatChange,
          items: [{
            min: 1,
            max: 10,
            value: {
              min: 1,
              max: 10
            }
          }]
        },
        features: {
          label: "Features",
          category: "amenities",
          param: "features",
          expanded: false,
          filterType: "checkbox",
          onChange: _this.onFilterChange,
          items: []
        },
        buildings: {
          label: "Buildings",
          category: "buildings",
          param: "library",
          expanded: false,
          filterType: "checkbox",
          onChange: _this.onFilterChange,
          items: []
        }
      }
    };
    _this.currentPage = 0;
    _this.$ajaxResults = _jquery["default"].ajax();
    _this.queryString = _queryString["default"].parse(location.search); // params in the url
    return _this;
  }
  _inherits(SpaceFinderApp, _Component);
  return _createClass(SpaceFinderApp, [{
    key: "updateUrl",
    value:
    // function takes two optional values
    // the url parameter and the value it should equal
    // if neither a parameter or value are passed,
    // we assume the queryString has been updated else where
    // and we just need to reset the url
    function updateUrl(param) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if a parameter and a value are passed add the new value
      if (param && value) {
        this.queryString[param] = value;
      }
      // if a parameter is passed with a value remove the parameter
      if (param && (value === null || value.length === 0)) {
        delete this.queryString[param];
      }
      var stringifiedQueries = _queryString["default"].stringify(this.queryString);
      var newUrl = window.location.origin + window.location.pathname + "?" + stringifiedQueries;
      window.history.replaceState({
        path: newUrl
      }, "", newUrl);
    }
  }, {
    key: "render",
    value:
    // ******* End Action Handlers **************** //

    function render() {
      var _this$state2 = this.state,
        activeSpace = _this$state2.activeSpace,
        filters = _this$state2.filters,
        mapResults = _this$state2.mapResults,
        results = _this$state2.results,
        showDetails = _this$state2.showDetails,
        showMap = _this$state2.showMap,
        showResults = _this$state2.showResults,
        hideFilters = _this$state2.hideFilters;
      var baseAssetsUrl = this.props.baseAssetsUrl;
      var gridModifier = showDetails ? "hl__space-finder__container--show-details" : hideFilters ? "hl__space-finder__container--no-filters" : " ";
      var resultsClass = !showResults ? "hl__space-finder__results--hidden" : "";
      var mapClass = !showMap ? "hl__space-finder__map--hidden" : "";
      var filterArray = [filters.roomTypes, filters.buildings, filters.noise, filters.seats, filters.features];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "hl__space-finder__container ".concat(gridModifier)
      }, /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__space-finder__menu-bar"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        disabled: showResults,
        onClick: this.onTabChange.bind(null, "list")
      }, "List"), /*#__PURE__*/_react["default"].createElement("button", {
        disabled: showMap,
        onClick: this.onTabChange.bind(null, "map")
      }, "Map")), /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__space-finder__filters"
      }, /*#__PURE__*/_react["default"].createElement(_filterRail["default"], {
        onAccordionChange: this.onAccordionChange,
        onHideFilters: this.onHideFilters,
        onClearAll: this.onClearAll,
        assetsUrl: baseAssetsUrl,
        title: "Filter Spaces",
        hideFilters: hideFilters || showDetails,
        message: "With thanks to our colleagues at Cambridge University",
        groups: filterArray
      })), /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__space-finder__results ".concat(resultsClass)
      }, /*#__PURE__*/_react["default"].createElement(_spacesResults["default"], _extends({}, results, {
        activeSpace: activeSpace,
        showDetails: showDetails,
        noise: filters.noise,
        assetsUrl: baseAssetsUrl,
        handleResultClick: this.onResultClick,
        handleCloseDetail: this.onHideDetail,
        handleLoadMore: this.onShowMore
      }))), /*#__PURE__*/_react["default"].createElement("section", {
        className: "hl__space-finder__map ".concat(mapClass)
      }, /*#__PURE__*/_react["default"].createElement(_spacesMap["default"], {
        markers: mapResults,
        assetsUrl: baseAssetsUrl,
        handleInfoClick: this.onResultClick,
        googleMapsApiKey: this.props.googleMapsApiKey
      })));
    }
  }]);
}(_react.Component);
_defineProperty(SpaceFinderApp, "propTypes", {
  baseRequestUrl: _propTypes.string.isRequired,
  baseAssetsUrl: _propTypes.string.isRequired,
  googleMapsApiKey: _propTypes.string.isRequired
});
_defineProperty(SpaceFinderApp, "defaultProps", {});

},{"../../02-molecules/forms/filter-rail.jsx":5,"../../03-organisms/general/spaces-results.jsx":13,"../../03-organisms/media/spaces-map.jsx":14,"jquery":"jquery","prop-types":"prop-types","query-string":"query-string","ramda":"ramda","react":"react"}],16:[function(require,module,exports){
"use strict";

var _react = _interopRequireDefault(require("react"));
var _reactDom = require("react-dom");
var _spaceFinderApp = _interopRequireDefault(require("./space-finder-app.jsx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var el = document.querySelector(".js-space-finder");
if (el) {
  var props = {
    baseRequestUrl: el.getAttribute("data-request-url"),
    baseAssetsUrl: el.getAttribute("data-assets-url"),
    googleMapsApiKey: typeof drupalSettings !== "undefined" && drupalSettings.harlibSpaceFinder && drupalSettings.harlibSpaceFinder.googleMapsApiKey ? drupalSettings.harlibSpaceFinder.googleMapsApiKey : null
  };
  (0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(_spaceFinderApp["default"], props), el);
}

},{"./space-finder-app.jsx":15,"react":"react","react-dom":"react-dom"}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default() {
  var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var date = new Date(Date.now());
  return "".concat(days[date.getDay()], ", ").concat(months[date.getMonth()], " ").concat(date.getDate());
};

},{}],18:[function(require,module,exports){
"use strict";

var _spaceFinder = _interopRequireDefault(require("../_patterns/04-templates/content-types/space-finder.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }

},{"../_patterns/04-templates/content-types/space-finder.js":16}]},{},[18]);
